export function reachGoal(event: string) {
  (window as any).ym("97669191", "reachGoal", event);
}
